import { render } from "./CreateItem.vue?vue&type=template&id=558789d3&scoped=true"
import script from "./CreateItem.vue?vue&type=script&lang=js"
export * from "./CreateItem.vue?vue&type=script&lang=js"

import "./CreateItem.vue?vue&type=style&index=0&id=558789d3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558789d3"]])

export default __exports__